import { useState } from "react";
import cls from "classnames";
import { useTranslation } from "react-i18next";
import { EyeOutlined, LoadingOutlined } from "@ant-design/icons";
import { downloadFile } from "logic/src/utils/download";
import { findElementWithClass } from "../../utils/dom";
import styles from "./index.module.scss";

import { ReactComponent as DownloadIcon } from "logic/src/components/icons/download.svg";

import { ReactComponent as GrayCloseIcon } from "logic/src/components/icons/gray_close.svg";

interface IProps {
  src: string;
  loading?: boolean;
  name?: string;
  className?: string;
  domMode?: boolean;
}

let hasListened = false;

const listenDom = () => {
  if (hasListened) return;

  hasListened = true;
  document.addEventListener("click", (e: MouseEvent) => {
    const opDom = findElementWithClass(e, styles.operationPreview);
    if (opDom) {
      const imageContainer = opDom?.parentElement?.previousElementSibling;
      imageContainer?.classList.add(styles.preview);
      return;
    }

    const downloadDom = findElementWithClass(e, styles.operationDownload);
    if (downloadDom && downloadDom.dataset.src && downloadDom?.dataset.name) {
      downloadFile(downloadDom.dataset.src, downloadDom?.dataset.name);
      return;
    }

    const closeBtn = findElementWithClass(e, styles.closeBtn);

    if (closeBtn) {
      const imageContainer = closeBtn?.parentElement?.parentElement;
      imageContainer?.classList.remove(styles.preview);
      return;
    }

    const maskDom = findElementWithClass(e, styles.preview);

    if (maskDom) {
      maskDom?.classList.remove(styles.preview);
      return;
    }
  });
};

const AiImage = ({ src, className, name, loading, domMode }: IProps) => {
  const [preview, setPreview] = useState<boolean>(false);
  const { t } = useTranslation();

  if (domMode) {
    listenDom();
  }

  return (
    <span className={cls(styles.container, className)}>
      {loading && (
        <div className={styles.loadingLayer}>
          <LoadingOutlined
            style={{ fontSize: 24 }}
            spin
            onPointerEnterCapture={() => {}}
            onPointerLeaveCapture={() => {}}
          />
          {/* 加载中... */}
          <div>{t("sensechat-262")}</div>
        </div>
      )}

      <div className={styles.imageHoverBox}>
        <div
          onClick={() => setPreview(false)}
          className={cls(styles.imageBox, preview && styles.preview)}
        >
          <div className={styles.imageShadow}>
            <GrayCloseIcon
              onClick={() => setPreview(false)}
              className={styles.closeBtn}
            />
            <img
              loading="lazy"
              onClick={e => e.stopPropagation()}
              className={styles.image}
              src={src}
            ></img>
          </div>
        </div>
        <div className={styles.operationBox}>
          <DownloadIcon
            className={styles.operationDownload}
            data-src={src}
            data-name={name}
            onClick={() => downloadFile(src, name)}
          />
          <EyeOutlined
            className={styles.operationPreview}
            onClick={() => setPreview(true)}
            onPointerEnterCapture={() => {}}
            onPointerLeaveCapture={() => {}}
          />
        </div>
      </div>
    </span>
  );
};

export default AiImage;
